import React from "react";
import * as Mui from "@mui/material";
import { SvgIconProps } from "@mui/material/SvgIcon";
import { designTokens } from "theme";

/**
 * Lucide's "sparkles" in brand orange, marking Search Agent features in lists and menus. A stroked
 * glyph, unlike the filled sparkle on the lead's Search Agent tab. Decorative: the label beside it
 * carries the meaning, so it stays out of the accessible name.
 *
 * Forwards its ref so MUI parents that attach one (Tooltip, ButtonBase) get the <svg>.
 */
const Component = React.forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => {
	const { style, ...others } = props;
	return (
		<Mui.SvgIcon
			viewBox="0 0 24 24"
			aria-hidden
			{...others}
			ref={ref}
			style={{ fontSize: 16, color: designTokens.colors.brandOrange, flexShrink: 0, ...style }}
		>
			<g fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
				<path d="M11.017 2.814a1 1 0 0 1 1.966 0l1.051 5.558a2 2 0 0 0 1.594 1.594l5.558 1.051a1 1 0 0 1 0 1.966l-5.558 1.051a2 2 0 0 0-1.594 1.594l-1.051 5.558a1 1 0 0 1-1.966 0l-1.051-5.558a2 2 0 0 0-1.594-1.594l-5.558-1.051a1 1 0 0 1 0-1.966l5.558-1.051a2 2 0 0 0 1.594-1.594z" />
				<path d="M20 2v4" />
				<path d="M22 4h-4" />
				<circle cx="4" cy="20" r="2" />
			</g>
		</Mui.SvgIcon>
	);
});

Component.displayName = "SparklesIcon";

export const SparklesIcon = Component;
